import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Topbar from '../components/Topbar';
import ProposicaoCard from '../components/ProposicaoCard';
import { Heart, Plus, Trash2 } from 'lucide-react';
import './WatchlistsPage.css';

interface Watchlist {
  id: string;
  nome: string;
  descricao: string;
  proposicoes: any[];
  contador: number;
}

export default function WatchlistsPage() {
  const [watchlists, setWatchlists] = useState<Watchlist[]>([]);
  const [selectedList, setSelectedList] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [novoNome, setNovoNome] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWatchlists = async () => {
      try {
        const res = await fetch('/api/watchlists');
        const data = await res.json();
        setWatchlists(data.results || []);
        if (data.results?.length > 0) {
          setSelectedList(data.results[0].id);
        }
      } catch (error) {
        console.error('Failed to fetch watchlists:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchWatchlists();
  }, []);

  const selected = watchlists.find((w) => w.id === selectedList);

  const handleAddWatchlist = () => {
    if (novoNome.trim()) {
      const novaLista: Watchlist = {
        id: `w${Date.now()}`,
        nome: novoNome,
        descricao: 'Nova lista de acompanhamento',
        proposicoes: [],
        contador: 0,
      };
      setWatchlists([...watchlists, novaLista]);
      setNovoNome('');
      setSelectedList(novaLista.id);
    }
  };

  const handleDeleteWatchlist = (id: string) => {
    setWatchlists(watchlists.filter((w) => w.id !== id));
    if (selectedList === id) {
      setSelectedList(watchlists[0]?.id || null);
    }
  };

  return (
    <div className="watchlists-container">
      <Topbar title="Watchlists" />
      <div className="watchlists-content">
        <div className="watchlists-sidebar">
          <div className="watchlists-header">
            <h2>Minhas Listas</h2>
          </div>

          <div className="watchlists-list">
            {watchlists.map((list) => (
              <button
                key={list.id}
                className={`watchlist-item ${selectedList === list.id ? 'active' : ''}`}
                onClick={() => setSelectedList(list.id)}
              >
                <div className="watchlist-item-icon">
                  <Heart size={16} />
                </div>
                <div className="watchlist-item-content">
                  <div className="watchlist-item-nome">{list.nome}</div>
                  <div className="watchlist-item-count">{list.contador} itens</div>
                </div>
              </button>
            ))}
          </div>

          <div className="watchlist-add">
            <input
              type="text"
              placeholder="Nome da lista..."
              value={novoNome}
              onChange={(e) => setNovoNome(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleAddWatchlist()}
              className="watchlist-input"
            />
            <button onClick={handleAddWatchlist} className="watchlist-add-btn">
              <Plus size={16} />
              Criar
            </button>
          </div>
        </div>

        <div className="watchlists-main">
          {loading ? (
            <div className="watchlist-loading">Carregando listas...</div>
          ) : selected ? (
            <>
              <div className="watchlist-header-detail">
                <div>
                  <h2>{selected.nome}</h2>
                  <p className="watchlist-description">{selected.descricao}</p>
                </div>
                {selected.id !== 'w1' && selected.id !== 'w2' && selected.id !== 'w3' && (
                  <button
                    className="watchlist-delete-btn"
                    onClick={() => handleDeleteWatchlist(selected.id)}
                    title="Deletar lista"
                  >
                    <Trash2 size={18} />
                  </button>
                )}
              </div>

              {selected.proposicoes.length > 0 ? (
                <div className="watchlist-items">
                  {selected.proposicoes.map((prop) => (
                    <ProposicaoCard
                      key={prop.id}
                      proposicao={prop}
                      variant="v2"
                    />
                  ))}
                </div>
              ) : (
                <div className="watchlist-empty">
                  <Heart size={48} strokeWidth={1} />
                  <p>Nenhuma proposição nesta lista</p>
                  <button
                    className="btn"
                    onClick={() => navigate('/search')}
                  >
                    Procurar proposições
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="watchlist-empty">
              Crie uma nova lista para começar
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
